import {base_uri} from './types/BS_types'

const prodPath = 'js/ring/'

if (__webpack_public_path__ === prodPath) {
  __webpack_public_path__ = `${base_uri}/${prodPath}`
}
